import React from 'react';
import { formatDate, getArtistInfo } from '../../../utils/formatters';

/**
 * Event card component for the timeline
 * @param {Object} props - Component props
 * @param {Object} props.event - Event data
 * @param {boolean} props.isSelected - Whether the event is selected
 * @param {Function} props.onSelect - Event selection handler
 */
const EventCard = ({ event, isSelected, onSelect }) => {
  return (
    <div 
      onClick={() => onSelect(event)}
      className={`p-3 rounded-lg shadow-sm cursor-pointer transition-all hover:shadow-md border-l-4 ${
        event.active ? 'border-green-500 bg-green-50' : 'border-blue-800 bg-gray-50'
      } ${isSelected ? 'ring-2 ring-blue-800' : ''}`}
    >
      <div className="flex justify-between items-start">
        <div>
          <h3 className="font-medium text-gray-900">{event.location}</h3>
          <p className="text-sm text-gray-600">{event.venue}</p>
          <p className="text-xs text-gray-500 mt-1">
            {formatDate(event.startDate)} - {formatDate(event.endDate)}
          </p>
          {event.active && (
            <div className="inline-flex items-center text-xs mt-1 px-2 py-0.5 bg-green-100 text-green-800 rounded">
              <span className="w-1.5 h-1.5 rounded-full bg-green-500 mr-1"></span>
              On display now
            </div>
          )}
        </div>
        <div className="bg-gray-100 px-2 py-0.5 rounded-full text-xs text-gray-600">
          {event.cars.length} {event.cars.length === 1 ? 'car' : 'cars'}
        </div>
      </div>
      <div className="mt-2 flex flex-wrap gap-1">
        {event.cars.map((car, idx) => {
          const carInfo = getArtistInfo(car);
          return (
            <div 
              key={idx} 
              className={`text-xs px-2 py-0.5 rounded-full ${
                carInfo 
                  ? 'bg-blue-100 text-blue-800 border border-blue-200' 
                  : 'bg-gray-100 text-gray-600 border border-gray-200'
              }`}
            >
              {car}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EventCard;